module.exports = __webpack_public_path__ + "static/media/www.humana.fi.b7057f83.png";